module.exports = __webpack_public_path__ + "assets/5778e96471746fac7c1e1fd5a85117d2.mp4";